import React from 'react'

export const BlogPage = () => {
    return (
        <div className="card sticky-action">
        ...
    
        <div className="card-action">...</div>
    
        <div className="card-reveal">...</div>
      </div>
    )
}